import apiCaller from 'util/apiCaller';

const getMeInfo = function* getMeInfo() {
  let data = apiCaller(`api/me`, 'GET', null);
  return yield data ? data : [];
}

const getListVaiTro = function* getListVaiTro() {
  let data = apiCaller(`api/vaitros/?keyword=&page=-1`, 'GET', null);
  return yield data ? data : [];
}

export const getInfo = {
  getMeInfo,
  getListVaiTro
};

